import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { desktopCSS, mobileCSS, tabletCSS } from '@measures/responsive'
import useClientViewportType from '@hooks/useClientViewportType'
import SportsPartnerComponent, {
  SportsPartnerProps as SportsPartnerComponentProps,
} from '@components/SportsPartner'

export interface SportsPartnerProps {
  partner: SportsPartnerComponentProps['partner']
  hasBundling?: boolean
  accentColor?: string
}

const StyledSportsPartner = styled(SportsPartnerComponent)<
  Pick<SportsPartnerProps, 'accentColor' | 'hasBundling'>
>`
  ${({
    theme: {
      spacing: { spacing16, spacing8 },
      measures: { outerPadding },
      colors: { staticRed500 },
    },
    accentColor,
    hasBundling,
  }) => css`
    margin-top: -${spacing16};

    ${desktopCSS(css`
      display: none;
    `)};

    ${mobileCSS(css`
      margin-left: -${outerPadding.mobile};
      margin-right: -${outerPadding.mobile};
      width: calc(100% + 2 * ${outerPadding.mobile});
    `)};

    ${hasBundling &&
    css`
      border-left: ${spacing8} solid ${accentColor ?? staticRed500};
      ${tabletCSS(css`
        margin-left: -${spacing16};
        width: calc(100% + ${spacing16});
      `)}
    `}
  `}
`

const SportsPartner: FunctionComponent<SportsPartnerProps> = ({
  partner,
  accentColor,
  hasBundling,
}) =>
  useClientViewportType() === 'desktop' ? null : (
    <StyledSportsPartner
      partner={partner}
      accentColor={accentColor}
      hasBundling={hasBundling}
    />
  )

export default SportsPartner
